import type { useTranslations } from 'next-intl'
import { BILLING_PLANS } from '@/lib/billing/plans'

/** `useTranslations('pricingPage')`. */
export type PricingTranslator = ReturnType<
  typeof useTranslations<'pricingPage'>
>

/**
 * Where the public pricing page's Enterprise buttons lead: the /enterprise
 * page, where a reader builds a plan and sees the price before a call. Each
 * button words itself ("Build your plan") from its own catalog.
 */
export const ENTERPRISE_PAGE_HREF = '/enterprise'

/**
 * Public comparison-table CTA copy. Deliberately no promo language: this
 * table is signed-out, and the commitment offer is only available to a
 * signed-in org that has never paid. Advertising it here would promise a
 * price we cannot honour for everyone who clicks.
 */
export function getPlanCtaLabel(t: PricingTranslator, plan: string): string {
  if (plan === BILLING_PLANS.free.name) {
    return t('comparison.startFree')
  }
  if (plan === BILLING_PLANS.enterprise.name) {
    return t('comparison.buildYourPlan')
  }
  return t('comparison.startWithPlan', { plan })
}
